import React, { forwardRef } from "react";
import styles from "./PrintHistoryVisitPdf.module.css";

const PrintHistoryVisitPdf = forwardRef(({ data, filterLabel = "" }, ref) => {
  const rows = data || [];

  return (
    <div ref={ref} className={styles.tableContainer}>
      <div className={styles.reportHeader}>
        <h2 className={styles.reportTitle}>Riwayat Kunjungan</h2>
        {filterLabel ? (
          <p className={styles.reportSubtitle}>{filterLabel}</p>
        ) : null}
        <p className={styles.reportMeta}>
          Dicetak: {new Date().toLocaleString("id-ID")}
        </p>
      </div>

      <table className={styles.visitTable}>
        <thead>
          <tr>
            <th>No. RM</th>
            <th>Dokter</th>
            <th>Nama Pasien</th>
            <th>Tanggal Lahir</th>
            <th>Jenis Kelamin</th>
            <th>Perawatan</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((item, index) => (
            <tr key={index}>
              <td>{item?.medicalRecordNumber || "-"}</td>
              <td>{item?.visit?.doctorName || "-"}</td>
              <td>{item?.name || "-"}</td>
              <td>{item?.dob || "-"}</td>
              <td>{item?.gender || "-"}</td>
              <td>{item?.visit?.treatment || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className={styles.wrapperTotal}>
        <p>Total Kunjungan</p>
        <p className={styles.totalValue}>{rows.length}</p>
      </div>
    </div>
  );
});

export default PrintHistoryVisitPdf;
